import React, { useContext, useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import FolderIcon from "@material-ui/icons/Folder";
import { IShareDocumentDialogProps } from "../../../../../../@types/components/ShareFolderDialogProps.types";
import { Backdrop, CircularProgress, FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import AutoCompleteChips from "../../../../../shared/autoCompleteWithChips/AutoCompleteWithChips";

import "./ShareDocumentDialog.css";
import { Member } from "../../../../../../@types/member.types";
import { IAdminDocumentPayload } from "../../../../../../@types/adminDocumentPayload.types";
import { IAdminDocumentSharePayload } from "../../../../../../@types/adminDocumentSharePayload.types";
import { trackPromise } from "react-promise-tracker";
import { api } from "../../../../../../utils/api";
import { IFileInfoDialogProps } from "../../../../../../@types/components/fileInfoDialogProps.types";
import { ThreeCircles } from "react-loader-spinner";
import { GROUP_NUMBER } from "../../../../../../constants/groups";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120
		},
		selectEmpty: {
			marginTop: theme.spacing(2)
		}
	})
);

const backdropStyles = makeStyles((theme: Theme) =>
	createStyles({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: "#fff",
			position: "absolute"
		}
	})
);
const ShareDocumentDialog = ({
	open,
	handleChangeShareDialogOpen,
	adminDocument,
	shareTo
}: IShareDocumentDialogProps) => {
	const classes = useStyles();
	const backdropClasses = backdropStyles();
	const [memberList, setMemberList] = useState<Member[]>([]);
	const [search, setSearch] = useState<string>("");
	const [groupNo, setGroupNo] = useState<number>(220);
	const [loading, setLoading] = useState<boolean>(false);

	const handleChangeShareMethod = (event: React.ChangeEvent<{ value: unknown }>) => {
		setSearch(event.target.value as string);
	};

	const handleChangeGroup = (event: React.ChangeEvent<{ value: unknown }>) => {
		const { value } = event.target;
		setGroupNo(Number(value));
	};

	const handleChangeMemberList = (value: Member[]) => {
		setMemberList(value);
	};

	const adminShareFile = async () => {
		if (adminDocument._id) {
			setLoading(true); // Set loading to true before making the API call
			const payload: IAdminDocumentSharePayload = {
				member_list: memberList,
				group_number: groupNo,
				group_owner_object_id: adminDocument.group_owner_object_id,
				shared_document_object_id: adminDocument._id
			};
			try {
				await trackPromise(api.documentSharing.adminShareFile(payload));
			} catch (error) {
				console.error("Error sharing file:", error);
			} finally {
				setLoading(false); // Set loading to false after the API call is complete
				handleChangeShareDialogOpen();
			}
		}
	};

	const adminShareDocumnetGroup = async () => {
		if (adminDocument._id) {
			// console.log("call");
			const payload = {
				group_number: groupNo,
				group_owner_object_id: adminDocument.group_owner_object_id,
				shared_document_object_id: adminDocument._id
			};
			try {
				setLoading(true);
				const response = await trackPromise(api.documentSharing.adminShareDocumentGroup(payload));
				if (response) {
					alert("Document Shared to Group Successfully");
				}
			} catch (error) {
				console.log(error);
			} finally {
				setLoading(false);
				handleChangeShareDialogOpen();
			}
		}
	};

	const handleShareButtonClick = () => {
		if (shareTo === "MEMBER") {
			adminShareFile();
		} else {
			adminShareDocumnetGroup();
		}
	};

	return (
		<div>
			<Dialog open={open} onClose={handleChangeShareDialogOpen} aria-labelledby="form-dialog-title">
				<DialogTitle id="form-dialog-title">
					<div className="dialog-heading">
						<FolderIcon style={{ color: "orange" }} fontSize="large" />
						<h3>Share Document</h3>
					</div>
				</DialogTitle>
				<DialogContent>
					<DialogContentText>Enter name or SSN or Member Id to share this document</DialogContentText>
					{shareTo === "MEMBER" ? (
						<div className="searchByShare">
							<FormControl className={classes.formControl}>
								<InputLabel id="demo-simple-select-label">Group No</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={groupNo}
									onChange={handleChangeGroup}
								>
									{Object.values(GROUP_NUMBER).map((value: any) => (
										<MenuItem key={GROUP_NUMBER + "v" + value} value={value}>
											{value}
										</MenuItem>
									))}
								</Select>
							</FormControl>
							<FormControl className={classes.formControl}>
								<InputLabel id="demo-simple-select-label">Search By</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={search}
									onChange={handleChangeShareMethod}
								>
									<MenuItem value={"member_id"}>Member Id</MenuItem>
									<MenuItem value={"first_name"}>First Name</MenuItem>
									<MenuItem value={"SSN"}>SSN</MenuItem>
								</Select>
							</FormControl>
							<AutoCompleteChips
								field={search}
								group_number={groupNo}
								handleChangeMemberList={handleChangeMemberList}
								key={0}
							/>
						</div>
					) : (
						<div className="searchByShare">
							<FormControl className={classes.formControl}>
								<InputLabel id="demo-simple-select-label">Group No</InputLabel>
								<Select
									labelId="demo-simple-select-label"
									id="demo-simple-select"
									value={groupNo}
									onChange={handleChangeGroup}
								>
									{Object.values(GROUP_NUMBER).map((value: any) => (
										<MenuItem key={GROUP_NUMBER + "v" + value} value={value}>
											{value}
										</MenuItem>
									))}
									{/* <MenuItem value={188}>188</MenuItem> */}
								</Select>
							</FormControl>
						</div>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleChangeShareDialogOpen} color="primary">
						Cancel
					</Button>
					{loading ? (
						<CircularProgress size={20} />
					) : (
						<Button color="primary" onClick={() => handleShareButtonClick()}>
							Share
						</Button>
					)}
				</DialogActions>
			</Dialog>
		</div>
	);
};
export default ShareDocumentDialog;
